

const calculateYoutubeBudget = ({
    budget,
    budgetType,
    startDate,
    endDate,
    feePercent = 10,
}) => {
    const baseBudget = Number(budget) || 0;
    let totalBudget = baseBudget;
    let diffDays = 1;

    // If daily, multiply by date interval
    if (budgetType === "daily" && startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);
        diffDays = Math.max(
            1,
            Math.ceil((end - start) / (1000 * 60 * 60 * 24))
        );
        totalBudget = baseBudget * diffDays;
    }

    const processingFee = (totalBudget * (feePercent / 100));
    const grandTotal = totalBudget + processingFee;

    return {
        totalBudget: Number(totalBudget.toFixed(2)),
        processingFee: Number(processingFee.toFixed(2)),
        grandTotal: Number(grandTotal.toFixed(2)),
        diffDays,
    }
}

const calculateTotalAmount = (extractedData, selectedDataPeriod) => {
    const today = new Date();
    const startDate = getStartDate(selectedDataPeriod, today);

    return extractedData
        ?.filter(item => {
            if (!item.createdAt) return false;
            const itemDate = new Date(item.createdAt);
            return itemDate >= startDate && itemDate <= today;
        })
        .reduce((sum, item) => sum + (item.amount || 0), 0);
};

const getStartDate = (period, today) => {
    const date = new Date(today);
    
    switch (period) {
        case 'weekly':
            date.setDate(date.getDate() - 6);
            return date;
        case 'monthly':
            date.setDate(date.getDate() - 29);
            return date;
        case 'yearly':
            date.setFullYear(date.getFullYear() - 1);
            return date;
        case 'all':
        default:
            return new Date(0);
    }
};

module.exports = {calculateYoutubeBudget, calculateTotalAmount}